import React from 'react'

const VerticalEllipses = (props) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <g transform="translate(10 2)" stroke="#000" fill="none" fillRule="evenodd" strokeLinecap="round"
               strokeLinejoin="round">
                <circle cx="2" cy="2" r="2"/>
                <circle cx="2" cy="10" r="2"/>
                <circle cx="2" cy="18" r="2"/>
            </g>
        </svg>

    )
}
export default VerticalEllipses
